module.exports = __webpack_public_path__ + "img/Lamborgini.a56fe20c.png";